import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

/** ANX-071: статусы присутствия оператора. 'offline' — производное (нет
 *  соединения), не выбирается оператором; используется только в индикаторе
 *  коллег. */
export type OperatorStatus = 'online' | 'away' | 'busy';

export interface Operator {
  id: string;
  tenantId: string;
  email: string;
  name: string;
  role: string;
  avatarUrl?: string;
  /** ANX-036: язык интерфейса, выбранный оператором. undefined = «язык
   *  браузера». Приходит с backend в login/refresh/me, тащит preference
   *  между устройствами. 'ru' | 'en'. */
  locale?: string;
  /** ANX-071: выбранный статус присутствия. Приходит с backend в
   *  login/refresh/me; меняется через PATCH /me/status. */
  presenceStatus?: OperatorStatus;
}

export interface AuthSession {
  access: string;
  refresh: string;
  /** Unix ms когда access-токен становится невалидным. */
  accessExpiresAt: number;
  operator: Operator;
}

interface AuthState {
  session: AuthSession | null;
  setSession: (session: AuthSession) => void;
  clear: () => void;
}

export const AUTH_STORAGE_KEY = 'anexica.auth.v1';

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      session: null,
      setSession: (session) => set({ session }),
      clear: () => set({ session: null }),
    }),
    {
      name: AUTH_STORAGE_KEY,
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
